import ListAltIcon from '@mui/icons-material/ListAlt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export const ManageList = [
    {
        name: 'Users',
        url: 'users',
        icon: <PeopleOutlineIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Players',
        url: 'players',
        icon: <PeopleOutlineIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Open Bets',
        url: 'open-bets',
        icon: <ListAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Sport History',
        url: 'sport-history',
        icon: <ListAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Casino History',
        url: 'casino-history',
        icon: <ListAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Transaction',
        url: 'transaction',
        icon: <ReceiptLongIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Deposits',
        url: 'deposits',
        icon: <ReceiptLongIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Cashback Transactions',
        url: 'cashback-transactions',
        icon: <ReceiptLongIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Announcements',
        url: 'announcements',
        icon: <ListAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    },
    {
        name: 'Create Account',
        url: 'create-account',
        icon: <PersonAddAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
    }
]

export const ROW_COLORS = [
    '#21242f',
    '#2a2e35',
    '#2e3643',
    '#364257',
    '#2e3d57',
    '#384761'
];
